import React from 'react';
import MarkdownDocPage from '../MarkdownDocPage';

export default function UserManualCollectionPointsPage() {
    return <MarkdownDocPage title="Collection points" markdownUrl="/docs/user-manual/pages/collection-points.md" />;
}

